import React from "react";
import styles from "./SkillWidget.module.css";

const SkillWidget = (props) => {
  return (
    <div 
      className={styles.skillWidget}
      style={{ '--skill-index': props.index || 0 }}
    >
      {props.skill}
    </div>
  );
};

export default SkillWidget;
